import * as React from 'react'
import { CustomType, GoalWithProgress, ProgressType } from '../../services/api.types'
import './YumGoalCard.scss'
import { Link } from 'react-router-dom'
import { getPeriodString } from '../../common/helpers/date'

import { ReactComponent as StepsImg } from '../../assets/challenges/steps.svg'
import { ReactComponent as ActivityIndexImg } from '../../assets/challenges/activity-index.svg'
import { ReactComponent as IntensiveMinutesImg } from '../../assets/challenges/intensive-minutes.svg'
import { ReactComponent as CollectiveStepsImg } from '../../assets/challenges/collective-steps.svg'
import { ReactComponent as CollectiveCaloriesImg } from '../../assets/challenges/collective-calories.svg'
import { ReactComponent as CollectiveMinutesImg } from '../../assets/challenges/collective-intensive-minutes.svg'
import { ReactComponent as PersistenceStepsImg } from '../../assets/challenges/persistence-steps.svg'
import { ReactComponent as PersistenceMinutesImg } from '../../assets/challenges/persistence-intensive-minutes.svg'
import { ReactComponent as PersistenceActivityIndexImg } from '../../assets/challenges/persistence-activity-index.svg'

import { ReactComponent as CustomImg } from '../../assets/challenges/custom.svg'
import { ReactComponent as PersistenceCustomImg } from '../../assets/challenges/persistence-custom.svg'
import { ReactComponent as CollectiveCustomImg } from '../../assets/challenges/collective-custom.svg'

import { ReactComponent as OutdoorTimeImg } from '../../assets/challenges/outdoor-time.svg'
import { ReactComponent as PersistenceOutdoorTimeImg } from '../../assets/challenges/persistence-outdoor-time.svg'
import { ReactComponent as CollectiveOutdoorTimeImg } from '../../assets/challenges/collective-outdoor-time.svg'

import { ReactComponent as SwimmingImg } from '../../assets/challenges/swimming.svg'
import { ReactComponent as PersistenceSwimmingImg } from '../../assets/challenges/persistence-swimming.svg'
import { ReactComponent as CollectiveSwimmingImg } from '../../assets/challenges/collective-swimming.svg'

import { ReactComponent as CyclingImg } from '../../assets/challenges/cycling.svg'
import { ReactComponent as PersistenceCyclingImg } from '../../assets/challenges/persistence-cycling.svg'
import { ReactComponent as CollectiveCyclingImg } from '../../assets/challenges/collective-cycling.svg'

import { ReactComponent as DistanceImg } from '../../assets/challenges/distance.svg'
import { ReactComponent as PersistenceDistanceImg } from '../../assets/challenges/persistence-distance.svg'
import { ReactComponent as CollectiveDistanceImg } from '../../assets/challenges/collective-distance.svg'

import { ReactComponent as PlankingImg } from '../../assets/challenges/planking.svg'
import { ReactComponent as PersistencePlankingImg } from '../../assets/challenges/persistence-planking.svg'
import { ReactComponent as CollectivePlankingImg } from '../../assets/challenges/collective-planking.svg'

import { ReactComponent as MindfulnessImg } from '../../assets/challenges/mindfulness.svg'
import { ReactComponent as PersistenceMindfulnessImg } from '../../assets/challenges/persistence-mindfulness.svg'
import { ReactComponent as CollectiveMindfulnessImg } from '../../assets/challenges/collective-mindfulness.svg'

import { ReactComponent as WaterDrinkingImg } from '../../assets/challenges/water-drinking.svg'
import { ReactComponent as PersistenceWaterDrinkingImg } from '../../assets/challenges/persistence-water-drinking.svg'
import { ReactComponent as CollectiveWaterDrinkingImg } from '../../assets/challenges/collective-water-drinking.svg'

import { ReactComponent as ExerciseImg } from '../../assets/challenges/exerice.svg'
import { ReactComponent as PersistenceExerciseImg } from '../../assets/challenges/persistence-exercise.svg'
import { ReactComponent as CollectiveExerciseImg } from '../../assets/challenges/collective-exercise.svg'

import { ReactComponent as YogaImg } from '../../assets/challenges/yoga.svg'
import { ReactComponent as PersistenceYogaImg } from '../../assets/challenges/persistence-yoga.svg'
import { ReactComponent as CollectiveYogaImg } from '../../assets/challenges/collective-yoga.svg'

import { ReactComponent as RunningImg } from '../../assets/challenges/running.svg'
import { ReactComponent as PersistenceRunningImg } from '../../assets/challenges/persistence-running.svg'
import { ReactComponent as CollectiveRunningImg } from '../../assets/challenges/collective-running.svg'

import { ReactComponent as WalkingImg } from '../../assets/challenges/walking.svg'
import { ReactComponent as PersistenceWalkingImg } from '../../assets/challenges/persistence-walking.svg'
import { ReactComponent as CollectiveWalkingImg } from '../../assets/challenges/collective-walking.svg'

import { ReactComponent as SleepImg } from '../../assets/challenges/sleep.svg'
import { ReactComponent as PersistenceSleepImg } from '../../assets/challenges/persistence-sleep.svg'
import { ReactComponent as CollectiveSleepImg } from '../../assets/challenges/collective-sleep.svg'

import { ReactComponent as PointsImg } from '../../assets/challenges/points.svg'
import { ReactComponent as PersistencePointsImg } from '../../assets/challenges/persistence-points.svg'
import { ReactComponent as CollectivePointsImg } from '../../assets/challenges/collective-points.svg'

import { ReactComponent as BookReadingImg } from '../../assets/challenges/book-reading.svg'
import { ReactComponent as PersistenceBookReadingImg } from '../../assets/challenges/persistence-book-reading.svg'
import { ReactComponent as CollectiveBookReadingImg } from '../../assets/challenges/collective-book-reading.svg'

import { ReactComponent as EncouragingSomeoneImg } from '../../assets/challenges/encouraging-someone.svg'
import { ReactComponent as PersistenceEncouragingSomeoneImg } from '../../assets/challenges/persistence-encouraging-someone.svg'
import { ReactComponent as CollectiveEncouragingSomeoneImg } from '../../assets/challenges/collective-encouraging-someone.svg'

import { ReactComponent as CarFreeDaysImg } from '../../assets/challenges/car-free-days.svg'
import { ReactComponent as PersistenceCarFreeDaysImg } from '../../assets/challenges/persistence-car-free-days.svg'
import { ReactComponent as CollectiveCarFreeDaysImg } from '../../assets/challenges/collective-car-free-days.svg'

import { ReactComponent as AlcoholAbstinenceImg } from '../../assets/challenges/alcohol-abstinence.svg'
import { ReactComponent as PersistenceAlcoholAbstinenceImg } from '../../assets/challenges/persistence-alcohol-abstience.svg'
import { ReactComponent as CollectiveAlcoholAbstinenceImg } from '../../assets/challenges/collective-alcohol-abstinence.svg'

import { ReactComponent as SquattingImg } from '../../assets/challenges/squatting.svg'
import { ReactComponent as PersistenceSquattingImg } from '../../assets/challenges/persistence-squatting.svg'
import { ReactComponent as CollectiveSquattingImg } from '../../assets/challenges/collective-squatting.svg'

import { ReactComponent as ContrastShowerImg } from '../../assets/challenges/contrast-shower.svg'
import { ReactComponent as PersistenceContrastShowerImg } from '../../assets/challenges/persistence-constrast-shower.svg'
import { ReactComponent as CollectiveContrastShowerImg } from '../../assets/challenges/collective-contrast-shower.svg'

import { ReactComponent as FinanceTrackingImg } from '../../assets/challenges/finance-tracking.svg'
import { ReactComponent as PersistenceFinanceTrackingImg } from '../../assets/challenges/persistence-finance-tracking.svg'
import { ReactComponent as CollectiveFinanceTrackingImg } from '../../assets/challenges/collective-finance-tracking.svg'

import { ReactComponent as HealthyCookingImg } from '../../assets/challenges/healthy-cooking.svg'
import { ReactComponent as PersistenceHealthyCookingImg } from '../../assets/challenges/persistence-healthy-cooking.svg'
import { ReactComponent as CollectiveHealthyCookingImg } from '../../assets/challenges/collective-healthy-cooking.svg'

import { ReactComponent as DeepBreathingImg } from '../../assets/challenges/deep-breathing.svg'
import { ReactComponent as PersistenceDeepBreathingImg } from '../../assets/challenges/persistence-deep-breathing.svg'
import { ReactComponent as CollectiveDeepBreathingImg } from '../../assets/challenges/collective-deep-breathing.svg'

import { ReactComponent as DailyJournalingImg } from '../../assets/challenges/daily-journaling.svg'
import { ReactComponent as PersistenceDailyJournalingImg } from '../../assets/challenges/persistence-daily-journaling.svg'
import { ReactComponent as CollectiveDailyJournalingImg } from '../../assets/challenges/collective-daily-journaling.svg'

import { ReactComponent as PushUpsImg } from '../../assets/challenges/push-ups.svg'
import { ReactComponent as PersistencePushUpsImg } from '../../assets/challenges/persistence-push-ups.svg'
import { ReactComponent as CollectivePushUpsImg } from '../../assets/challenges/collective-push-ups.svg'

import { ReactComponent as PullUpsImg } from '../../assets/challenges/pull-ups.svg'
import { ReactComponent as PersistencePullUpsImg } from '../../assets/challenges/persistence-pull-ups.svg'
import { ReactComponent as CollectivePullUpsImg } from '../../assets/challenges/collective-pull-ups.svg'

import { ReactComponent as CreativeArtsImg } from '../../assets/challenges/creative-arts.svg'
import { ReactComponent as PersistenceCreativeArtsImg } from '../../assets/challenges/persistence-creative-arts.svg'
import { ReactComponent as CollectiveCreativeArtsImg } from '../../assets/challenges/collective-creative-arts.svg'

import { ReactComponent as SocializingWithFriendsImg } from '../../assets/challenges/socializing-with-friends.svg'
import { ReactComponent as PersistenceSocializingWithFriends } from '../../assets/challenges/persistence-socializing-with-friends.svg'
import { ReactComponent as CollectiveSocializingWithFriends } from '../../assets/challenges/collective-socializing-with-friends.svg'

import { ReactComponent as ColdPlungeImg } from '../../assets/challenges/cold-plunge.svg'
import { ReactComponent as PersistenceColdPlungeImg } from '../../assets/challenges/persistence-cold-plunge.svg'
import { ReactComponent as CollectiveColdPlungeImg } from '../../assets/challenges/collective-cold-plunge.svg'

import { ReactComponent as IntermittentFastingImg } from '../../assets/challenges/intermittent-fasting.svg'
import { ReactComponent as PersistenceIntermittentFastingImg } from '../../assets/challenges/persistence-intermittent-fasting.svg'
import { ReactComponent as CollectiveIntermittentFastingImg } from '../../assets/challenges/collective-intermittent-fasting.svg'

import { ReactComponent as GratitudeJournalingImg } from '../../assets/challenges/gratitude-journaling.svg'
import { ReactComponent as PersistenceGratitudeJournalingImg } from '../../assets/challenges/persistence-gratitude-journaling.svg'
import { ReactComponent as CollectiveGratitudeJournalingImg } from '../../assets/challenges/collective-gratitude-journaling.svg'

import { ReactComponent as LanguageLearningImg } from '../../assets/challenges/language-learning.svg'
import { ReactComponent as PersistenceLanguageLearningImg } from '../../assets/challenges/persistence-language-learning.svg'
import { ReactComponent as CollectiveLanguageLearningImg } from '../../assets/challenges/collective-language-learning.svg'

import { ReactComponent as HobbyDevelopmentImg } from '../../assets/challenges/hobby-development.svg'
import { ReactComponent as PersistenceHobbyDevelopmentImg } from '../../assets/challenges/persistence-hobby-development.svg'
import { ReactComponent as CollectiveHobbyDevelopmentImg } from '../../assets/challenges/collective-hobby-development.svg'

import { ReactComponent as NaturalLightExposureImg } from '../../assets/challenges/natural-light-exposure.svg'
import { ReactComponent as PersistenceNaturalLightExposureImg } from '../../assets/challenges/persistence-natural-light-exposure.svg'
import { ReactComponent as CollectiveNaturalLightExposureImg } from '../../assets/challenges/collective-natural-light-exposure.svg'

import { ReactComponent as SmokingCessationImg } from '../../assets/challenges/smoking-cessation.svg'
import { ReactComponent as PersistenceSmokingCessationImg } from '../../assets/challenges/persistence-smoking-cessation.svg'
import { ReactComponent as CollectiveSmokingCessationImg } from '../../assets/challenges/collective-smoking-cessation.svg'

import { ReactComponent as PhoneFreeTimeImg } from '../../assets/challenges/phone-free-time.svg'
import { ReactComponent as PersistencePhoneFreeTimeImg } from '../../assets/challenges/persistence-phone-free-time.svg'
import { ReactComponent as CollectivePhoneFreeTimeImg } from '../../assets/challenges/collective-phone-free-time.svg'

import { ReactComponent as CaffeineReductionImg } from '../../assets/challenges/caffeine-reduction.svg'
import { ReactComponent as PersistenceCaffeineReductionImg } from '../../assets/challenges/persistence-caffeine-reduction.svg'
import { ReactComponent as CollectiveCaffeineReductionImg } from '../../assets/challenges/collective-caffeine-reduction.svg'

import { ReactComponent as ScreenFreeMealsImg } from '../../assets/challenges/screen-free-meals.svg'
import { ReactComponent as PersistenceScreenFreeMealsImg } from '../../assets/challenges/persistence-screen-free-meals.svg'
import { ReactComponent as CollectiveScreenFreeMealsImg } from '../../assets/challenges/collective-screen-free-meals.svg'

import { ReactComponent as DailyFlossingImg } from '../../assets/challenges/daily-flossing.svg'
import { ReactComponent as PersistenceDailyFlossingImg } from '../../assets/challenges/persistence-daily-flossing.svg'
import { ReactComponent as CollectiveDailyFlossingImg } from '../../assets/challenges/collective-daily-flossing.svg'

import { ReactComponent as StressLevelMonitoringImg } from '../../assets/challenges/stress-level-monitoring.svg'
import { ReactComponent as PersistenceStressLevelMonitoringImg } from '../../assets/challenges/persistence-stress-level-monitoring.svg'
import { ReactComponent as CollectiveStressLevelMonitoringImg } from '../../assets/challenges/collective-stress-level-monitoring.svg'

import { ReactComponent as MoodTrackingImg } from '../../assets/challenges/mood-tracking.svg'
import { ReactComponent as PersistenceMoodTrackingImg } from '../../assets/challenges/persistence-mood-tracking.svg'
import { ReactComponent as CollectiveMoodTrackingImg } from '../../assets/challenges/collective-mood-tracking.svg'

import { isCollectiveType } from '../../common/helpers/challenges'
import { currentLang } from '../../i18nInit'
import YumChallengeActionsWrapper from '../YumChallengeActions/YumChallengeActionsWrapper'

export interface IYumGoalCardProps {
  goal: GoalWithProgress
}

export class YumGoalCard extends React.PureComponent<IYumGoalCardProps> {
  getPeriodText = (startDateNumber: number, endDateNumber: number) => getPeriodString(startDateNumber, endDateNumber)

  getIllustration = (progressType: ProgressType, customType: CustomType | null) => {
    switch (progressType) {
      // Deprecated
      case ProgressType.STEPS:
        return {
          Illustration: StepsImg,
          backgroundColor: '#E7F1FF',
        }
      // Deprecated
      case ProgressType.INTENSIVE_MINUTES:
        return {
          Illustration: IntensiveMinutesImg,
          backgroundColor: '#FFE2E5',
        }
      // Deprecated
      case ProgressType.COLLECTIVE_STEPS:
        return {
          Illustration: CollectiveStepsImg,
          backgroundColor: '#E7F1FF',
        }
      // Deprecated
      case ProgressType.COLLECTIVE_CALORIES:
        return {
          Illustration: CollectiveCaloriesImg,
          backgroundColor: '#FFE1A7',
        }
      // Deprecated
      case ProgressType.COLLECTIVE_INTENSIVE_MINUTES:
        return {
          Illustration: CollectiveMinutesImg,
          backgroundColor: '#FFE2E5',
        }
      case ProgressType.COLLECTIVE_CUSTOM:
        switch (customType) {
          case CustomType.STEPS:
            return {
              Illustration: CollectiveStepsImg,
              backgroundColor: '#E7F1FF',
            }
          case CustomType.CALORIES:
            return {
              Illustration: CollectiveCaloriesImg,
              backgroundColor: '#FFE1A7',
            }
          case CustomType.INTENSIVE_MINUTES:
            return {
              Illustration: CollectiveMinutesImg,
              backgroundColor: '#FFE2E5',
            }
          case CustomType.POINTS:
            return {
              Illustration: CollectivePointsImg,
              backgroundColor: '#D3F2FF',
            }
          case CustomType.SLEEP_HR:
          case CustomType.SLEEP_MIN:
            return {
              Illustration: CollectiveSleepImg,
              backgroundColor: '#503493',
            }
          case CustomType.OUTDOOR_TIME_HR:
          case CustomType.OUTDOOR_TIME_MIN:
            return {
              Illustration: CollectiveOutdoorTimeImg,
              backgroundColor: '#FFF2D8',
            }
          case CustomType.SWIMMING_M:
          case CustomType.SWIMMING_YD:
          case CustomType.SWIMMING_KM:
          case CustomType.SWIMMING_MI:
          case CustomType.SWIMMING_MIN:
          case CustomType.SWIMMING_HR:
            return {
              Illustration: CollectiveSwimmingImg,
              backgroundColor: '#DAEAFF',
            }
          case CustomType.CYCLING_HR:
          case CustomType.CYCLING_KM:
          case CustomType.CYCLING_MI:
          case CustomType.CYCLING_MIN:
            return {
              Illustration: CollectiveCyclingImg,
              backgroundColor: '#E0E1FF',
            }
          case CustomType.DISTANCE_KM:
          case CustomType.DISTANCE_MI:
            return {
              Illustration: CollectiveDistanceImg,
              backgroundColor: '#D6E2F1',
            }
          case CustomType.PLANKING_MIN:
          case CustomType.PLANKING_HR:
            return {
              Illustration: CollectivePlankingImg,
              backgroundColor: '#E4EEF8',
            }
          case CustomType.MINDFULNESS_HR:
          case CustomType.MINDFULNESS_MIN:
            return {
              Illustration: CollectiveMindfulnessImg,
              backgroundColor: '#8A83E3',
            }
          case CustomType.WATER_DRINKING_CUP:
          case CustomType.WATER_DRINKING_GLASS:
          case CustomType.WATER_DRINKING_ML:
          case CustomType.WATER_DRINKING_OZ:
            return {
              Illustration: CollectiveWaterDrinkingImg,
              backgroundColor: '#6DCDF4',
            }
          case CustomType.EXERCISE_HR:
          case CustomType.EXERCISE_MIN:
            return {
              Illustration: CollectiveExerciseImg,
              backgroundColor: '#F8CD43',
            }
          case CustomType.YOGA_MIN:
          case CustomType.YOGA_HR:
            return {
              Illustration: CollectiveYogaImg,
              backgroundColor: '#DEF0DC',
            }
          case CustomType.RUNNING_KM:
          case CustomType.RUNNING_MI:
          case CustomType.RUNNING_MIN:
          case CustomType.RUNNING_HR:
            return {
              Illustration: CollectiveRunningImg,
              backgroundColor: '#847BF4',
            }
          case CustomType.WALKING_KM:
          case CustomType.WALKING_MI:
          case CustomType.WALKING_HR:
          case CustomType.WALKING_MIN:
            return {
              Illustration: CollectiveWalkingImg,
              backgroundColor: '#DEE9FF',
            }

          case CustomType.BOOK_READING_MIN:
          case CustomType.BOOK_READING_BOOKS:
          case CustomType.BOOK_READING_PAGES:
            return {
              Illustration: CollectiveBookReadingImg,
              backgroundColor: '#FFE8D2',
            }
          case CustomType.ENCOURAGING_PEOPLE:
            return {
              Illustration: CollectiveEncouragingSomeoneImg,
              backgroundColor: '#FED8E6',
            }
          case CustomType.CAR_FREE_DAYS:
            return {
              Illustration: CollectiveCarFreeDaysImg,
              backgroundColor: '#E6EFFF',
            }
          case CustomType.ALCOHOL_ABSTINENCE:
            return {
              Illustration: CollectiveAlcoholAbstinenceImg,
              backgroundColor: '#3A133A',
            }
          case CustomType.SQUATTING:
            return {
              Illustration: CollectiveSquattingImg,
              backgroundColor: '#FFDFDF',
            }
          case CustomType.CONTRAST_SHOWER_SEC:
            return {
              Illustration: CollectiveContrastShowerImg,
              backgroundColor: '#C8E6FF',
            }
          case CustomType.FINANCE_TRACKING:
            return {
              Illustration: CollectiveFinanceTrackingImg,
              backgroundColor: '#CBF5DF',
            }
          case CustomType.HEALTHY_COOKING_MEALS:
            return {
              Illustration: CollectiveHealthyCookingImg,
              backgroundColor: '#FFEFCA',
            }
          case CustomType.DEEP_BREATHING_MIN:
            return {
              Illustration: CollectiveDeepBreathingImg,
              backgroundColor: '#FFE7E6',
            }
          case CustomType.DAILY_JOURNALING:
            return {
              Illustration: CollectiveDailyJournalingImg,
              backgroundColor: '#F5E5FB',
            }
          case CustomType.PUSH_UPS:
            return {
              Illustration: CollectivePushUpsImg,
              backgroundColor: '#FBEEE5',
            }
          case CustomType.PULL_UPS:
            return {
              Illustration: CollectivePullUpsImg,
              backgroundColor: '#FBEFD1',
            }
          case CustomType.CREATIVE_ARTS_MIN:
            return {
              Illustration: CollectiveCreativeArtsImg,
              backgroundColor: '#F1F1EF',
            }
          case CustomType.SOCIALIZING_WITH_FRIENDS_MIN:
            return {
              Illustration: CollectiveSocializingWithFriends,
              backgroundColor: '#F0F0F0',
            }
          case CustomType.COLD_PLUNGE_SEC:
            return {
              Illustration: CollectiveColdPlungeImg,
              backgroundColor: '#79C7F4',
            }
          case CustomType.INTERMITTENT_FASTING_HR:
            return {
              Illustration: CollectiveIntermittentFastingImg,
              backgroundColor: '#F2F6FA',
            }
          case CustomType.GRATITUDE_JOURNALING:
            return {
              Illustration: CollectiveGratitudeJournalingImg,
              backgroundColor: '#FBDB6B',
            }
          case CustomType.LANGUAGE_LEARNING_MIN:
            return {
              Illustration: CollectiveLanguageLearningImg,
              backgroundColor: '#FBE1AF',
            }
          case CustomType.HOBBY_DEVELOPMENT_MIN:
            return {
              Illustration: CollectiveHobbyDevelopmentImg,
              backgroundColor: '#121B3E',
            }
          case CustomType.NATURAL_LIGHT_EXPOSURE:
            return {
              Illustration: CollectiveNaturalLightExposureImg,
              backgroundColor: '#DBEFF7',
            }
          case CustomType.SMOKING_CESSATION:
            return {
              Illustration: CollectiveSmokingCessationImg,
              backgroundColor: '#F3EADD',
            }
          case CustomType.PHONE_FREE_TIME_HR:
            return {
              Illustration: CollectivePhoneFreeTimeImg,
              backgroundColor: '#F9E5E0',
            }
          /*case CustomType.CAFFEINE_REDUCTION:
            return {
              Illustration: CollectiveCaffeineReductionImg,
              backgroundColor: '#FAE5CE',
            }*/
          case CustomType.SCREEN_FREE_MEALS:
            return {
              Illustration: CollectiveScreenFreeMealsImg,
              backgroundColor: '#6CC5D1',
            }
          case CustomType.DAILY_FLOSSING:
            return {
              Illustration: CollectiveDailyFlossingImg,
              backgroundColor: '#FFCDDC',
            }
          /*case CustomType.STRESS_LEVEL_MONITORING:
            return {
              Illustration: CollectiveStressLevelMonitoringImg,
              backgroundColor: '#F9B9B9',
            }
          case CustomType.MOOD_TRACKING:
            return {
              Illustration: CollectiveMoodTrackingImg,
              backgroundColor: '#FFEAB5',
            }*/

          default:
            return {
              Illustration: CollectiveCustomImg,
              backgroundColor: '#E1F2FF',
            }
        }

      // Deprecated
      case ProgressType.PERSISTENCE_STEPS:
        return {
          Illustration: PersistenceStepsImg,
          backgroundColor: '#E7F1FF',
        }
      // Deprecated
      case ProgressType.PERSISTENCE_INTENSIVE_MINUTES:
        return {
          Illustration: PersistenceMinutesImg,
          backgroundColor: '#FFE2E5',
        }
      case ProgressType.PERSISTENCE_ALL:
        return {
          Illustration: PersistenceActivityIndexImg,
          backgroundColor: '#D4E6FD',
        }

      case ProgressType.PERSISTENCE_CUSTOM:
      case ProgressType.PERSISTENCE_CUSTOM_BINARY:
        switch (customType) {
          case CustomType.STEPS:
            return {
              Illustration: PersistenceStepsImg,
              backgroundColor: '#E7F1FF',
            }
          case CustomType.INTENSIVE_MINUTES:
            return {
              Illustration: PersistenceMinutesImg,
              backgroundColor: '#FFE2E5',
            }
          case CustomType.POINTS:
            return {
              Illustration: PersistencePointsImg,
              backgroundColor: '#D3F2FF',
            }
          case CustomType.SLEEP_HR:
          case CustomType.SLEEP_MIN:
            return {
              Illustration: PersistenceSleepImg,
              backgroundColor: '#503493',
            }
          case CustomType.OUTDOOR_TIME_HR:
          case CustomType.OUTDOOR_TIME_MIN:
            return {
              Illustration: PersistenceOutdoorTimeImg,
              backgroundColor: '#FFF2D8',
            }
          case CustomType.SWIMMING_M:
          case CustomType.SWIMMING_YD:
          case CustomType.SWIMMING_KM:
          case CustomType.SWIMMING_MI:
          case CustomType.SWIMMING_MIN:
          case CustomType.SWIMMING_HR:
            return {
              Illustration: PersistenceSwimmingImg,
              backgroundColor: '#DAEAFF',
            }
          case CustomType.CYCLING_HR:
          case CustomType.CYCLING_KM:
          case CustomType.CYCLING_MI:
          case CustomType.CYCLING_MIN:
            return {
              Illustration: PersistenceCyclingImg,
              backgroundColor: '#E0E1FF',
            }
          case CustomType.DISTANCE_KM:
          case CustomType.DISTANCE_MI:
            return {
              Illustration: PersistenceDistanceImg,
              backgroundColor: '#D6E2F1',
            }
          case CustomType.PLANKING_MIN:
          case CustomType.PLANKING_HR:
            return {
              Illustration: PersistencePlankingImg,
              backgroundColor: '#E4EEF8',
            }
          case CustomType.MINDFULNESS_HR:
          case CustomType.MINDFULNESS_MIN:
            return {
              Illustration: PersistenceMindfulnessImg,
              backgroundColor: '#8A83E3',
            }
          case CustomType.WATER_DRINKING_CUP:
          case CustomType.WATER_DRINKING_GLASS:
          case CustomType.WATER_DRINKING_ML:
          case CustomType.WATER_DRINKING_OZ:
            return {
              Illustration: PersistenceWaterDrinkingImg,
              backgroundColor: '#6DCDF4',
            }
          case CustomType.EXERCISE_HR:
          case CustomType.EXERCISE_MIN:
            return {
              Illustration: PersistenceExerciseImg,
              backgroundColor: '#F8CD43',
            }
          case CustomType.YOGA_MIN:
          case CustomType.YOGA_HR:
            return {
              Illustration: PersistenceYogaImg,
              backgroundColor: '#DEF0DC',
            }
          case CustomType.RUNNING_KM:
          case CustomType.RUNNING_MI:
          case CustomType.RUNNING_MIN:
          case CustomType.RUNNING_HR:
            return {
              Illustration: PersistenceRunningImg,
              backgroundColor: '#847BF4',
            }
          case CustomType.WALKING_KM:
          case CustomType.WALKING_MI:
          case CustomType.WALKING_HR:
          case CustomType.WALKING_MIN:
            return {
              Illustration: PersistenceWalkingImg,
              backgroundColor: '#DEE9FF',
            }

          case CustomType.BOOK_READING_MIN:
          case CustomType.BOOK_READING_BOOKS:
          case CustomType.BOOK_READING_PAGES:
            return {
              Illustration: PersistenceBookReadingImg,
              backgroundColor: '#FFE8D2',
            }
          case CustomType.ENCOURAGING_PEOPLE:
            return {
              Illustration: PersistenceEncouragingSomeoneImg,
              backgroundColor: '#FED8E6',
            }
          case CustomType.CAR_FREE_DAYS:
            return {
              Illustration: PersistenceCarFreeDaysImg,
              backgroundColor: '#E6EFFF',
            }
          case CustomType.ALCOHOL_ABSTINENCE:
            return {
              Illustration: PersistenceAlcoholAbstinenceImg,
              backgroundColor: '#3A133A',
            }
          case CustomType.SQUATTING:
            return {
              Illustration: PersistenceSquattingImg,
              backgroundColor: '#FFDFDF',
            }
          case CustomType.CONTRAST_SHOWER_SEC:
            return {
              Illustration: PersistenceContrastShowerImg,
              backgroundColor: '#C8E6FF',
            }
          case CustomType.FINANCE_TRACKING:
            return {
              Illustration: PersistenceFinanceTrackingImg,
              backgroundColor: '#CBF5DF',
            }
          case CustomType.HEALTHY_COOKING_MEALS:
            return {
              Illustration: PersistenceHealthyCookingImg,
              backgroundColor: '#FFEFCA',
            }
          case CustomType.DEEP_BREATHING_MIN:
            return {
              Illustration: PersistenceDeepBreathingImg,
              backgroundColor: '#FFE7E6',
            }
          case CustomType.DAILY_JOURNALING:
            return {
              Illustration: PersistenceDailyJournalingImg,
              backgroundColor: '#F5E5FB',
            }
          case CustomType.PUSH_UPS:
            return {
              Illustration: PersistencePushUpsImg,
              backgroundColor: '#FBEEE5',
            }
          case CustomType.PULL_UPS:
            return {
              Illustration: PersistencePullUpsImg,
              backgroundColor: '#FBEFD1',
            }
          case CustomType.CREATIVE_ARTS_MIN:
            return {
              Illustration: PersistenceCreativeArtsImg,
              backgroundColor: '#F1F1EF',
            }
          case CustomType.SOCIALIZING_WITH_FRIENDS_MIN:
            return {
              Illustration: PersistenceSocializingWithFriends,
              backgroundColor: '#F0F0F0',
            }
          case CustomType.COLD_PLUNGE_SEC:
            return {
              Illustration: PersistenceColdPlungeImg,
              backgroundColor: '#79C7F4',
            }
          case CustomType.INTERMITTENT_FASTING_HR:
            return {
              Illustration: PersistenceIntermittentFastingImg,
              backgroundColor: '#F2F6FA',
            }
          case CustomType.GRATITUDE_JOURNALING:
            return {
              Illustration: PersistenceGratitudeJournalingImg,
              backgroundColor: '#FBDB6B',
            }
          case CustomType.LANGUAGE_LEARNING_MIN:
            return {
              Illustration: PersistenceLanguageLearningImg,
              backgroundColor: '#FBE1AF',
            }
          case CustomType.HOBBY_DEVELOPMENT_MIN:
            return {
              Illustration: PersistenceHobbyDevelopmentImg,
              backgroundColor: '#121B3E',
            }
          case CustomType.NATURAL_LIGHT_EXPOSURE:
            return {
              Illustration: PersistenceNaturalLightExposureImg,
              backgroundColor: '#DBEFF7',
            }
          case CustomType.SMOKING_CESSATION:
            return {
              Illustration: PersistenceSmokingCessationImg,
              backgroundColor: '#F3EADD',
            }
          case CustomType.PHONE_FREE_TIME_HR:
            return {
              Illustration: PersistencePhoneFreeTimeImg,
              backgroundColor: '#F9E5E0',
            }
          /*case CustomType.CAFFEINE_REDUCTION:
            return {
              Illustration: PersistenceCaffeineReductionImg,
              backgroundColor: '#FAE5CE',
            }*/
          case CustomType.SCREEN_FREE_MEALS:
            return {
              Illustration: PersistenceScreenFreeMealsImg,
              backgroundColor: '#6CC5D1',
            }
          case CustomType.DAILY_FLOSSING:
            return {
              Illustration: PersistenceDailyFlossingImg,
              backgroundColor: '#FFCDDC',
            }
          /*case CustomType.STRESS_LEVEL_MONITORING:
            return {
              Illustration: PersistenceStressLevelMonitoringImg,
              backgroundColor: '#F9B9B9',
            }
          case CustomType.MOOD_TRACKING:
            return {
              Illustration: PersistenceMoodTrackingImg,
              backgroundColor: '#FFEAB5',
            }*/
          default:
            return {
              Illustration: PersistenceCustomImg,
              backgroundColor: '#E1F2FF',
            }
        }

      case ProgressType.CUSTOM:
        switch (customType) {
          case CustomType.STEPS:
            return {
              Illustration: StepsImg,
              backgroundColor: '#E7F1FF',
            }
          case CustomType.INTENSIVE_MINUTES:
            return {
              Illustration: IntensiveMinutesImg,
              backgroundColor: '#FFE2E5',
            }
          case CustomType.POINTS:
            return {
              Illustration: PointsImg,
              backgroundColor: '#D3F2FF',
            }
          case CustomType.SLEEP_HR:
          case CustomType.SLEEP_MIN:
            return {
              Illustration: SleepImg,
              backgroundColor: '#503493',
            }
          case CustomType.OUTDOOR_TIME_HR:
          case CustomType.OUTDOOR_TIME_MIN:
            return {
              Illustration: OutdoorTimeImg,
              backgroundColor: '#FFF2D8',
            }
          case CustomType.SWIMMING_M:
          case CustomType.SWIMMING_YD:
          case CustomType.SWIMMING_KM:
          case CustomType.SWIMMING_MI:
          case CustomType.SWIMMING_MIN:
          case CustomType.SWIMMING_HR:
            return {
              Illustration: SwimmingImg,
              backgroundColor: '#DAEAFF',
            }
          case CustomType.CYCLING_HR:
          case CustomType.CYCLING_KM:
          case CustomType.CYCLING_MI:
          case CustomType.CYCLING_MIN:
            return {
              Illustration: CyclingImg,
              backgroundColor: '#E0E1FF',
            }
          case CustomType.DISTANCE_KM:
          case CustomType.DISTANCE_MI:
            return {
              Illustration: DistanceImg,
              backgroundColor: '#D6E2F1',
            }
          case CustomType.PLANKING_MIN:
          case CustomType.PLANKING_HR:
            return {
              Illustration: PlankingImg,
              backgroundColor: '#E4EEF8',
            }
          case CustomType.MINDFULNESS_HR:
          case CustomType.MINDFULNESS_MIN:
            return {
              Illustration: MindfulnessImg,
              backgroundColor: '#8A83E3',
            }
          case CustomType.WATER_DRINKING_CUP:
          case CustomType.WATER_DRINKING_GLASS:
          case CustomType.WATER_DRINKING_ML:
          case CustomType.WATER_DRINKING_OZ:
            return {
              Illustration: WaterDrinkingImg,
              backgroundColor: '#6DCDF4',
            }
          case CustomType.EXERCISE_HR:
          case CustomType.EXERCISE_MIN:
            return {
              Illustration: ExerciseImg,
              backgroundColor: '#F8CD43',
            }
          case CustomType.YOGA_MIN:
          case CustomType.YOGA_HR:
            return {
              Illustration: YogaImg,
              backgroundColor: '#DEF0DC',
            }
          case CustomType.RUNNING_KM:
          case CustomType.RUNNING_MI:
          case CustomType.RUNNING_MIN:
          case CustomType.RUNNING_HR:
            return {
              Illustration: RunningImg,
              backgroundColor: '#847BF4',
            }
          case CustomType.WALKING_KM:
          case CustomType.WALKING_MI:
          case CustomType.WALKING_HR:
          case CustomType.WALKING_MIN:
            return {
              Illustration: WalkingImg,
              backgroundColor: '#DEE9FF',
            }

          case CustomType.BOOK_READING_MIN:
          case CustomType.BOOK_READING_BOOKS:
          case CustomType.BOOK_READING_PAGES:
            return {
              Illustration: BookReadingImg,
              backgroundColor: '#FFE8D2',
            }
          case CustomType.ENCOURAGING_PEOPLE:
            return {
              Illustration: EncouragingSomeoneImg,
              backgroundColor: '#FED8E6',
            }
          case CustomType.CAR_FREE_DAYS:
            return {
              Illustration: CarFreeDaysImg,
              backgroundColor: '#E6EFFF',
            }
          case CustomType.ALCOHOL_ABSTINENCE:
            return {
              Illustration: AlcoholAbstinenceImg,
              backgroundColor: '#3A133A',
            }
          case CustomType.SQUATTING:
            return {
              Illustration: SquattingImg,
              backgroundColor: '#FFDFDF',
            }
          case CustomType.CONTRAST_SHOWER_SEC:
            return {
              Illustration: ContrastShowerImg,
              backgroundColor: '#C8E6FF',
            }
          case CustomType.FINANCE_TRACKING:
            return {
              Illustration: FinanceTrackingImg,
              backgroundColor: '#CBF5DF',
            }
          case CustomType.HEALTHY_COOKING_MEALS:
            return {
              Illustration: HealthyCookingImg,
              backgroundColor: '#FFEFCA',
            }
          case CustomType.DEEP_BREATHING_MIN:
            return {
              Illustration: DeepBreathingImg,
              backgroundColor: '#FFE7E6',
            }
          case CustomType.DAILY_JOURNALING:
            return {
              Illustration: DailyJournalingImg,
              backgroundColor: '#F5E5FB',
            }
          case CustomType.PUSH_UPS:
            return {
              Illustration: PushUpsImg,
              backgroundColor: '#FBEEE5',
            }
          case CustomType.PULL_UPS:
            return {
              Illustration: PullUpsImg,
              backgroundColor: '#FBEFD1',
            }
          case CustomType.CREATIVE_ARTS_MIN:
            return {
              Illustration: CreativeArtsImg,
              backgroundColor: '#F1F1EF',
            }
          case CustomType.SOCIALIZING_WITH_FRIENDS_MIN:
            return {
              Illustration: SocializingWithFriendsImg,
              backgroundColor: '#F0F0F0',
            }
          case CustomType.COLD_PLUNGE_SEC:
            return {
              Illustration: ColdPlungeImg,
              backgroundColor: '#79C7F4',
            }
          case CustomType.INTERMITTENT_FASTING_HR:
            return {
              Illustration: IntermittentFastingImg,
              backgroundColor: '#F2F6FA',
            }
          case CustomType.GRATITUDE_JOURNALING:
            return {
              Illustration: GratitudeJournalingImg,
              backgroundColor: '#FBDB6B',
            }
          case CustomType.LANGUAGE_LEARNING_MIN:
            return {
              Illustration: LanguageLearningImg,
              backgroundColor: '#FBE1AF',
            }
          case CustomType.HOBBY_DEVELOPMENT_MIN:
            return {
              Illustration: HobbyDevelopmentImg,
              backgroundColor: '#121B3E',
            }
          case CustomType.NATURAL_LIGHT_EXPOSURE:
            return {
              Illustration: NaturalLightExposureImg,
              backgroundColor: '#DBEFF7',
            }
          case CustomType.SMOKING_CESSATION:
            return {
              Illustration: SmokingCessationImg,
              backgroundColor: '#F3EADD',
            }
          case CustomType.PHONE_FREE_TIME_HR:
            return {
              Illustration: PhoneFreeTimeImg,
              backgroundColor: '#F9E5E0',
            }
          /*case CustomType.CAFFEINE_REDUCTION:
            return {
              Illustration: CaffeineReductionImg,
              backgroundColor: '#FAE5CE',
            }*/
          case CustomType.SCREEN_FREE_MEALS:
            return {
              Illustration: ScreenFreeMealsImg,
              backgroundColor: '#6CC5D1',
            }
          case CustomType.DAILY_FLOSSING:
            return {
              Illustration: DailyFlossingImg,
              backgroundColor: '#FFCDDC',
            }
          /*case CustomType.STRESS_LEVEL_MONITORING:
            return {
              Illustration: StressLevelMonitoringImg,
              backgroundColor: '#F9B9B9',
            }
          case CustomType.MOOD_TRACKING:
            return {
              Illustration: MoodTrackingImg,
              backgroundColor: '#FFEAB5',
            }*/

          default:
            return {
              Illustration: CustomImg,
              backgroundColor: '#E1F2FF',
            }
        }

      default:
        return {
          Illustration: ActivityIndexImg,
          backgroundColor: '#D4E6FD',
        }
    }
  }

  render() {
    const { goal } = this.props
    const {
      id: goalId,
      progressType,
      startDate,
      endDate,
      companyId,
      collectivePercentage,
      totalPercentage,
      companyName,
      companyLogo,
      title,
      voucher,
      participating,
      participantsCount,
      customType,
      illustrationUrl,
      illustrationColor,
      logoUrl,
    } = goal

    const logo = logoUrl || companyLogo

    const {
      Illustration,
      backgroundColor: defaultBackgroundColor,
      // alignBottom,
    } = this.getIllustration(progressType, customType)
    const backgroundColor = illustrationColor || defaultBackgroundColor
    const illustrationStyle: any = {
      backgroundColor,
      alignItems: /*alignBottom && !illustrationUrl ? 'flex-end' :*/ 'center',
      padding: illustrationUrl ? '20px' : '0 20px',
    }

    const cover = illustrationColor === 'cover'
    if (cover) {
      illustrationStyle.backgroundImage = 'url(' + illustrationUrl + ')'
      illustrationStyle.backgroundSize = 'cover'
    }

    const isFutureChallenge = startDate > new Date().getTime()
    const isCollectiveChallenge = isCollectiveType(progressType)
    const progressPercentage = (isCollectiveChallenge ? collectivePercentage : totalPercentage) || '0'

    return (
      <>
        <Link className={`yum-goal-card`} to={`/challenges/${goalId}/${participating ? 'ranking' : 'info'}`}>
          <div className="yum-goal-card__illustration" style={illustrationStyle}>
            {illustrationUrl ? (
              <>
                {!cover && (
                  <img
                    src={illustrationUrl}
                    alt="Illustration"
                    style={{ display: 'block', maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto' }}
                  />
                )}
              </>
            ) : (
              <Illustration />
            )}
          </div>

          {!logo ? (
            <div className="yum-goal-card__organizer-name">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="12" height="12" rx="6" fill="#24284E" />
              </svg>
              {companyName}
            </div>
          ) : (
            <div className="yum-goal-card__organizer-logo">
              <img src={logo} alt={companyName} />
            </div>
          )}
          {title !== null ? <div className="yum-goal-card__title">{title}</div> : ''}
          {title === null && voucher ? <div className="yum-goal-card__title">{voucher}</div> : ''}

          <div className="yum-goal-card__footer">
            <div
              className={`yum-goal-card__stats ${
                !participating && !participantsCount ? 'yum-goal-card__stats--empty' : ''
              }`}
            >
              {!isFutureChallenge && participating ? (
                <div className="yum-goal-card__stats-item">
                  <div className="yum-goal-card__stats-item-icon yum-goal-card__stats-item-icon--progress" />
                  <div className="yum-goal-card__stats-item-text">{progressPercentage}%</div>
                </div>
              ) : (
                ''
              )}
              <div className="yum-goal-card__stats-item">
                <div className="yum-goal-card__stats-item-icon yum-goal-card__stats-item-icon--participants" />
                <div className="yum-goal-card__stats-item-text">{participantsCount || '0'}</div>
              </div>
              {startDate && endDate ? (
                <div className="yum-goal-card__stats-item">
                  <div className="yum-goal-card__stats-item-icon yum-goal-card__stats-item-icon--period" />
                  <div className="yum-goal-card__stats-item-text">{this.getPeriodText(startDate, endDate)}</div>
                </div>
              ) : (
                ''
              )}
            </div>

            <YumChallengeActionsWrapper className="__actions-wrapper" goal={goal} isListView={true} />
          </div>
        </Link>
      </>
    )
  }
}
